import React, {useEffect} from 'react';
import {connect, Provider} from "react-redux";

import store from "./redux/Store";

import NavBar from "./components/NavBar";
import Menu from "./components/Menu";
import Detail from "./components/Detail";
import {globalCheckSession} from "./redux/globalActions";
import Spinny from "./components/Spinny";
import Login from "./components/Login";

const mapState = state => ({
    global: state.global
});
const mapDispatch = dispatch => ({
    actionCheckSession: () => dispatch(globalCheckSession())
});
const BootstrapComponent = ({global, actionCheckSession}) => {
    useEffect(() => {
        actionCheckSession();
    }, []);

    if (global.initialLoad) {
        // wait for useEffect actionGetSims()
        return null;
    } else if (global.showLogin) {
        // show login
        return <Login />
    } else {
        // show detail
        return <React.Fragment>
            <NavBar/>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-6">
                        <Menu/>
                    </div>
                    <div className="col-6">
                        <Detail/>
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }
};
const Bootstrap = connect(mapState, mapDispatch)(BootstrapComponent);

function App() {
    return (
        <Provider store={store}>
            <Spinny/>
            <Bootstrap/>
        </Provider>
    );
}

export default App;
